export default __webpack_public_path__ + "static/media/SBIYonoLogo.0514a877.png";